// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"c1b55b1c","233":"d0ff4588","486":"cfea5673","678":"9bb0861d"}[chunkId] + ".js";
};